export async function localLLM(prompt: string) {
  try {
    const r = await fetch("http://localhost:11434/api/generate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ 
        model: "llama3.2:3b", 
        prompt, 
        stream: false, 
        options: { temperature: 0.2 } 
      })
    });
    
    if (!r.ok) {
      throw new Error(`Ollama request failed: ${r.statusText}`);
    }
    
    const data = await r.json();
    return (data?.response ?? "").trim();
  } catch (error) {
    console.error('Local LLM error:', error);
    // Fallback to mock response for development
    return JSON.stringify({
      name: "Unknown Card",
      set: "Unknown Set",
      condition: "NM",
      confidence: 0.5,
      estimatedPrice: 50,
      reasoning: "Fallback response - Ollama not available"
    });
  }
}

export async function identifyCard(hints: string): Promise<any> {
  const prompt = `Identify this Pokémon TCG card from two photos.
Return JSON with: name, set (if visible), condition guess (NM/LP/MP/HP/DMG), and confidence 0-1.
Hints: ${hints}
Return ONLY JSON.`;
  
  const response = await localLLM(prompt);
  try {
    return JSON.parse(response);
  } catch (error) {
    console.error('Failed to parse identification result:', error);
    return {
      name: "Unknown Card",
      set: "Unknown Set", 
      condition: "NM",
      confidence: 0.5
    };
  }
}

export async function generateDescription(name: string, set?: string, condition?: string): Promise<string> {
  const prompt = `Write a concise Tradera listing.
Rules: 60–90 words, neutral tone, no emojis.
Include: **${name} — ${set ?? "Unknown set"}** (bold at start), condition ${condition ?? "Unspecified"},
packaging (sleeve + toploader), shipping line for Sweden, and a one-liner collector hook.
Return ONLY the description text.`;
  
  return await localLLM(prompt);
}

export async function estimatePrice(name: string, set?: string, condition?: string): Promise<any> {
  const prompt = `Analyze the market value for this Pokémon TCG card.
Card: ${name} from ${set ?? "Unknown set"} in ${condition ?? "Unknown"} condition.
Consider: condition, set rarity, card popularity, recent market trends.
Return a JSON object with: estimatedPrice (number), confidence (0-1), reasoning (brief explanation).
Return ONLY JSON.`;
  
  const response = await localLLM(prompt);
  try {
    return JSON.parse(response);
  } catch (error) {
    console.error('Failed to parse price estimation:', error);
    return {
      estimatedPrice: 50,
      confidence: 0.5,
      reasoning: "Fallback estimation"
    };
  }
}
